import { Component, Vue } from 'vue-property-decorator';
import { PortalTarget } from 'portal-vue';

@Component({
  components: {
    PortalTarget
  }
})
export default class ClProvider extends Vue {}
